import ChapterDisplay from './ChapterDisplay';
import Comments from './Comments';

export default function Capitulo12() {
    const section = 'de-regreso-al-inicio';
    const title = 'De regreso al inicio';
    const description = 'Después de todo lo que pasó, sabía que la única forma de acabar con la pesadilla era con valentía.';
    const text = '<p>Me concentré en todos los momentos bonitos de mi vida, en el amor de mis papás, en mis primos, en mis amigos, ¡y hasta en el gran corazón de Taquito! Con todo ese poder, soplé sobre Camazotz y lo atrapé en una pequeña piedra. La misión no era fácil, y yo misma me convertí en la guardiana de ese monstruo, con el destino de todos en mis manos.</p><p>Pero antes de irnos, teníamos que despedirnos de mi amigo, mi héroe. Con Choc y Tinskani a mi lado, le dije adiós al perrito que se había sacrificado por mí. Me dolió en el alma ver cómo su cuerpo se hacía polvo y ese polvo se iba flotando por el universo. ¡Pude sentir el amor de él por todas partes! Fue un momento triste, pero al mismo tiempo sentí tanta paz, porque sabía que Taquito siempre estaría conmigo, en mi corazón.</p><p>Con la tristeza a un lado, Tinskani y yo nos lanzamos a la aventura de regresar a casa. La única salida era una estela de <b>mariposas monarca</b>, ¡un camino mágico que nos llevaría de vuelta!</p><p>Para los pueblos purépechas y otros de Mesoamérica, la llegada de millones de mariposas monarca cada año era un evento mágico y sagrado. Ellos creían que estas mariposas, con sus alas color naranja brillante, eran las almas de los guerreros y antepasados que regresaban a visitarlos. El viaje tan largo e increíble que hacen desde Canadá les parecía una prueba de que eran mensajeras entre el mundo de los vivos y el de los muertos. Esta creencia es muy bonita porque nos enseña que nuestros antepasados veían a la naturaleza con mucho respeto y le encontraban un significado profundo. Las monarcas nos recuerdan que la vida es un ciclo, que nuestros seres queridos nunca nos abandonan del todo y que, a veces, las cosas más hermosas son las que viajan más lejos para encontrarnos.</p><p>Pero no era tan fácil, porque las mariposas me advirtieron de unas sombras que se alimentan de la tristeza. Tenía que concentrarme y mantener la calma, porque mi felicidad era mi escudo. Y así, entre millones de mariposas, me enfrenté a mis miedos y emociones para llegar a casa, ¡con un brillo en el alma que nadie podría apagar!</p>';
    const image = 'https://www.diadelavida.com/images/chapters/deco_capitulo12.png?v='+Date.now();
    const image_number = 'https://www.diadelavida.com/images/numbers/12.png'
    const image_size = 'contain';
    const image_position = 'right';
    const image_height = 400;
    const comments_prompt = '¿Has vivistado algún sanctuario de mariposas monarca? ¿Qué te pareció? ¡Deja tu comentario!';

    const images = [
        {
            id: 1,
            src: 'https://www.diadelavida.com/images/chapters/capitulo12_main.jpg',
            alt: 'Noche de Muertos | Día de la Vida - Capítulo 12',
            description: 'Siempre con mejor amigo'
        },
        {
            id: 2,
            src: 'https://diadelavida.com/images/cards/card_depredadores_01.jpg',
            alt: 'Noche de Muertos | Día de la Vida - Capítulo 12',
            description: 'La ansiedad y el miedo son los peores depredadores'
        },
    ];

    return (
        <div>
            <ChapterDisplay
                section={section}
                title={title}
                description={description}
                text={text}
                image={image}
                imageSize={image_size}
                imagePosition={image_position}
                imageHeight={image_height}
                images={images}
                imageNumber={image_number}
            />
            <div id='users-comments'>
                <div className="comments-deco"></div>
                <div className="container">
                    <div className="row">
                        <Comments sectionId={section} commentsPrompt={comments_prompt} />
                    </div>
                </div>
            </div>
        </div>
    );
}